// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinner__svg {
  perspective: 10000px;
}
.spinner__svg__circle {
  will-change: transform;
  stroke-linecap: round;
  transform-origin: center;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AppSpinner/AppSpinner.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,oBAAA;AACJ;AACI;EACE,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kCAAA;AACN;;AAIA;EACE;IACE,uBAAA;EADF;EAGA;IACE,yBAAA;EADF;AACF","sourcesContent":[".spinner {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  \r\n  &__svg {\r\n    perspective: 10000px;\r\n\r\n    &__circle {\r\n      will-change: transform;\r\n      stroke-linecap: round;\r\n      transform-origin: center;\r\n      animation: spin 1s linear infinite;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
